import { render, staticRenderFns } from "./BoxCodeEdit2.vue?vue&type=template&id=11b2c678&scoped=true"
import script from "./BoxCodeEdit2.vue?vue&type=script&lang=js"
export * from "./BoxCodeEdit2.vue?vue&type=script&lang=js"
import style0 from "./BoxCodeEdit2.vue?vue&type=style&index=0&id=11b2c678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2c678",
  null
  
)

export default component.exports